import { useQuery } from '@tanstack/react-query'
import api from '@/core/api'

export const useParseHealthCheck = (enabled: boolean = true) => {
  const parseHealthQuery = useQuery({
    queryKey: ['parse-health'],
    queryFn: async () => {
      try {
        await api.healthcheck.checkParseHealth()
        return { healthy: true }
      } catch (error: any) {
        console.log('Parse health check error:', error)
        throw error
      }
    },
    enabled,
    retry: 1,
    refetchInterval: false,
    refetchOnWindowFocus: false
  })

  return {
    data: parseHealthQuery.data,
    isLoading: parseHealthQuery.isLoading,
    error: parseHealthQuery.error
  }
}

export const useStrapiHealthCheck = (enabled: boolean = true) => {
  const strapiHealthQuery = useQuery({
    queryKey: ['strapi-health'],
    queryFn: async () => {
      try {
        await api.strapi.getBlogPostsByCategory({ categorySlug: 'test', limit: 1 })
        return { healthy: true }
      } catch (error: any) {
        console.log('Strapi health check error:', error)
        throw error
      }
    },
    enabled,
    retry: 1,
    refetchInterval: false,
    refetchOnWindowFocus: false
  })

  return {
    data: strapiHealthQuery.data,
    isLoading: strapiHealthQuery.isLoading,
    error: strapiHealthQuery.error
  }
}

export const useBackendHealthCheck = (requiredBackend: 'parse' | 'strapi' | null) => {
  const parseHealth = useParseHealthCheck(requiredBackend === 'parse')
  const strapiHealth = useStrapiHealthCheck(requiredBackend === 'strapi')

  if (requiredBackend === 'parse') {
    return parseHealth
  }

  if (requiredBackend === 'strapi') {
    return strapiHealth
  }

  return {
    data: { healthy: true },
    isLoading: false,
    error: null
  }
}
